// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__2UQcM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 134
// module chunks = 0